module.exports = "/assets/5ff998e7133216d6256b45920168108d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/9Y.png
// module id = 2307
// module chunks = 0